import { render, staticRenderFns } from "./historyPeojects.vue?vue&type=template&id=e54d580e&scoped=true"
import script from "./historyPeojects.vue?vue&type=script&lang=js"
export * from "./historyPeojects.vue?vue&type=script&lang=js"
import style0 from "./historyPeojects.vue?vue&type=style&index=0&id=e54d580e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54d580e",
  null
  
)

export default component.exports